import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-film-line text-lg text-white"></i>
              </div>
              <span className="font-heading font-bold text-xl text-white whitespace-nowrap">777影院</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              777影院致力于为全球华人提供高清免费影视资源。电影、电视剧、综艺、动漫，超清画质，流畅不卡顿，完全免费，无广告打扰。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">影视分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-2 text-xs`}></i>
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  最新电影
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  热门剧集
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">联系方式</h4>
            <ul className="space-y-2.5 text-sm text-foreground-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-foreground-500"></i>
                <span>contact@777cinema.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-line mt-0.5 text-foreground-500"></i>
                <span>在线客服：7x24小时</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-foreground-500"></i>
                <span>安全绿色，无病毒无插件</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 777影院 版权所有 | 本站所有资源均来自互联网，仅供网友学习交流
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-foreground-300 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-foreground-300 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}